import {LocalizedString} from "../Children";
import {CommonProps} from "../CommonProps";

/**
 * A link, including a localized label
 */
export type LocalizedLink =
    { label: LocalizedString }
    & (
        {
            href: string;
            onClick?: never;
        } | {
            href?: never;
            onClick: () => unknown;
        }
    )
    & { disabled?: boolean}
    & { ariaLabel?: LocalizedString }
    ;

export type LocalizedBold = { boldText: LocalizedString };

/**
 * Creates a `LocalizedLink` with an onClick handler
 * @param onClick click handler
 * @param label link label
 */
export function buttonLink(
    onClick: () => unknown,
    label: LocalizedString,
    disabled?: boolean
): LocalizedLink {
    return {
        onClick,
        label,
        disabled,
    };
}

export function inlineLink(
    params: {
        label: LocalizedString,
        onClick: () => unknown,
        disabled?: boolean,
        ariaLabel?: LocalizedString,
    }
): LocalizedLink {
    return {
        ...params
    };
}

export function bold(text: LocalizedString): LocalizedBold {
    return { boldText: text };
}

export type Linebreak = { type: "linebreak" };

export const linebreak: Linebreak = {
    type: "linebreak",
};

export type LocalizedItem = LocalizedString | LocalizedLink | LocalizedBold | Linebreak;


export type TextChildren =
    | LocalizedString
    | LocalizedLink
    | LocalizedBold
    | Linebreak
    | [LocalizedItem, ...LocalizedItem[]];

export function isLinebreak(textChild: TextChildren): textChild is Linebreak {
    return "type" in textChild && textChild.type === "linebreak";
}

export type CommonTextProps = Omit<CommonProps, "width"> & {
    /**
     * Content of the element. Accepts a LocalizedString or a list mixing localized strings and links
     *
     * @example
     * <Body size="medium" weight="regular">
     *   {[
     *     localizedContent,
     *     link('#href', localizedLinkLabel),
     *     moreLocalizedContent
     *   ]}
     * </Body>
     */
    children: TextChildren;
    overflowWrap?: "anywhere" | "break-word";
};